import { clsx } from 'clsx'
import { Image } from 'component/Image'
import { Loader } from 'component/Loader/Loader'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { useEffect, useMemo, useState } from 'react'
import { InferenceStore } from 'store/inference/InferenceStore'
import css from './ProcessingCard.module.scss'

type Props = {
  inference: InferenceStore
  animated?: boolean
}

export const ProcessingCard = observer(({ inference, animated }: Props) => {
  const images = inference.selected_item_images
  const start = useMemo(() => Date.now(), [])
  const [active, setActive] = useState(images.length)

  const update = useLatestCallback(() => {
    const single = 5000
    const count = images.length
    const passed = Date.now() - start
    const active = Math.trunc(Math.trunc(passed / single) % count)
    setActive(active)
  })

  useEffect(() => {
    if (!animated) return
    const id = setInterval(update, 10)
    return () => clearInterval(id)
  }, [animated])

  return (
    <Vertical className={clsx(css.card, animated ? css.animated : css.static)}>
      {images.map((image, index) => {
        const className = clsx(css.slide, index === active && css.active)
        return (
          <Space key={index} className={className}>
            <Image src={image} />
          </Space>
        )
      })}
      {!images.length && <Space className={css.blank} tall center>
        <Loader />
      </Space>}
    </Vertical>
  )
})
